import styled from "styled-components";

import { colorsPalettes, mixins } from "@similarweb/styles";

import { StyledQuotaContainer } from "app/pages/sales-intelligence/modules/quota/containers/QuotaContainer/styles";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledHeaderContent = styled(FlexRow)`
    align-items: center;
    justify-content: space-between;
    margin-top: 6px;
    position: relative;

    ${StyledQuotaContainer} {
        position: absolute;
        right: 0;
        top: -50%;
    }
`;

export const StyledHeaderDescription = styled.p`
    ${mixins.setFontVariant("body2", colorsPalettes.carbon["400"])};
    margin: 0;
`;

export const StyledHeaderTitle = styled.h1`
    ${mixins.setFontVariant("h2", colorsPalettes.carbon["400"])};
    margin: 0;
`;

export const StyledHeaderContainer = styled.div`
    padding-top: 25px;
`;

export const StyledHeaderContentWrapper = styled.div`
    position: relative;
`;
